import { createSelector } from "reselect";

const selectConfigs = (state) => state.configs;

const selectMarketIso = () =>
  createSelector(selectConfigs, (configsState) => configsState?.marketIso);

const selectUserMarkets = () =>
  createSelector(selectConfigs, (configsState) => configsState?.userMarkets);

const selectLocations = (market) =>
  createSelector(selectConfigs, (configsState) => {
    const allLocations = configsState?.locations;

    if (allLocations) {
      return market ? allLocations[market] : allLocations;
    } else {
      return null;
    }
  });

const selectAppType = () => createSelector(selectConfigs, (configsState) => configsState?.appType);

const selectAppTypes = () =>
  createSelector(selectConfigs, (configsState) => configsState?.appTypes);

const selectAppTypesGroups = () =>
  createSelector(selectConfigs, (configsState) => configsState?.appTypesGroups);

const selectGroupsConfigs = () =>
  createSelector(selectConfigs, (configsState) => configsState?.groupsConfigs);

const selectUsersMarketFilter = () =>
  createSelector(selectConfigs, (configsState) => configsState?.userMarketFilter);

const selectAppVersion = () =>
  createSelector(selectConfigs, (configsState) => configsState?.appVersion);

const selectUserRoles = () =>
  createSelector(selectConfigs, (configsState) => configsState?.userRoles);

export {
  selectMarketIso,
  selectUserMarkets,
  selectLocations,
  selectAppType,
  selectAppTypes,
  selectUsersMarketFilter,
  selectAppTypesGroups,
  selectGroupsConfigs,
  selectAppVersion,
  selectUserRoles
};
